var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIconGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 234,
    viewBox: "0 0 299 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.253 132.368L298.291 226.945C300.164 230.791 298.196 233.938 293.918 233.938H5.08233C0.80448 233.938 -1.16394 230.791 0.708721 226.945L46.7479 132.368C47.4802 130.864 49.4487 129.633 51.1215 129.633H90.5978C91.8143 129.633 93.4574 130.395 94.2537 131.315C96.932 134.41 99.6602 137.433 102.38 140.426C104.964 143.267 107.561 146.145 110.138 149.091H63.2891C61.6158 149.091 59.6474 150.322 58.9155 151.826L28.4165 214.481H270.582L240.086 151.826C239.354 150.322 237.385 149.091 235.712 149.091H188.757C191.333 146.145 193.931 143.267 196.515 140.426C199.243 137.424 201.987 134.407 204.671 131.311C205.467 130.393 207.106 129.633 208.321 129.633H247.88C249.553 129.633 251.52 130.863 252.253 132.368ZM217.186 67.7355C217.186 119.414 174.164 129.106 153.931 178.769C152.287 182.804 146.606 182.784 144.961 178.749C126.709 133.972 89.9304 121.693 82.8937 81.8027C75.9654 42.5325 103.155 4.06508 142.854 0.312429C183.229 -3.50422 217.186 28.1502 217.186 67.7355ZM185.221 67.7355C185.221 47.98 169.207 31.9649 149.451 31.9649C129.695 31.9649 113.68 47.98 113.68 67.7355C113.68 87.4915 129.695 103.506 149.451 103.506C169.207 103.506 185.221 87.4915 185.221 67.7355Z",
    fill: "url(#paint0_linear_655_15824)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_655_15824",
    x1: 0,
    y1: 0,
    x2: 318.101,
    y2: 29.7591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD1C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C82021"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconGradient);
export default __webpack_public_path__ + "static/media/location-icon-gradient.136dac64d3a2454e85d6aed419bbfb35.svg";
export { ForwardRef as ReactComponent };